import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
  size?: "small" | "medium" | "large";
}

export default function ComicCard({ comic, size = "medium" }: ComicCardProps) {
  const sizeClasses = {
    small: "w-[140px]",
    medium: "w-[180px]",
    large: "w-[220px]",
  };

  const imageHeight = {
    small: "h-[190px]",
    medium: "h-[250px]",
    large: "h-[310px]",
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className={`${sizeClasses[size]} group block no-underline`}
    >
      <div
        className={`${imageHeight[size]} relative overflow-hidden rounded-lg bg-background-200`}
      >
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩漫在线观看`}
          title={`${comic.title} - 免费韩国漫画下拉式阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <span className="inline-block px-2 py-1 text-xs rounded bg-primary-500 text-background-50 whitespace-nowrap">
            {comic.status}
          </span>
        </div>
        {comic.rating >= 4.8 && (
          <div className="absolute top-2 right-2 px-1.5 py-0.5 text-xs rounded bg-accent-500 text-background-50 font-semibold whitespace-nowrap">
            HOT
          </div>
        )}
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-100 truncate group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-accent-500">
            <i className="ri-star-fill text-[10px] mr-0.5"></i>
            {comic.rating}
          </span>
        </div>
        {size !== "small" && (
          <div className="flex flex-wrap gap-1.5 mt-2">
            {comic.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 text-[10px] rounded-full bg-background-200/60 text-foreground-500 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}